import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props} >
    <path d="M2.66634 2.6665H13.333C14.0663 2.6665 14.6663 3.2665 14.6663 3.99984V11.9998C14.6663 12.7332 14.0663 13.3332 13.333 13.3332H2.66634C1.93301 13.3332 1.33301 12.7332 1.33301 11.9998V3.99984C1.33301 3.2665 1.93301 2.6665 2.66634 2.6665Z"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.6663 4L7.99967 8.66667L1.33301 4"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);


export default Icon;